import Element from 'element-ui'
import Vue from 'vue'
import {
    VueJsonp
} from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.use(Element)
